module.exports = __webpack_public_path__ + "img/order.0bf6bde6.png";